import { outter_post } from 'common/js/axios-helper';
import { PosApi,Merchant } from "./constant/UrlMapper";
const host = "8885";



const recoverycz = (data) => {
    return outter_post(PosApi.RecoveryCz, data, host);
};
const posmanageList = (data) => {
    return outter_post(Merchant.PosManageList, data, host);
};
const posmanagejijuInfo = (data) => {
    return outter_post(PosApi.PosManagejijuList, data, host);
};
const posJiJuType = (data) => { //机具活动类型
    return outter_post(PosApi.PosJiJuType, data, host);
};
const posYingJianType = (data) => { //硬件产品类型
    return outter_post(PosApi.PosYingJianType, data, host);
};
const posSuoShuType = (data) => { //所属组织
    return outter_post(PosApi.PosSuoShuType, data, host);
};
const posexchangeType = (data) => { //兑换类型
    return outter_post(PosApi.PosExchangeType, data, host);
};
const possourceArea = (data) => { //货源地
    return outter_post(PosApi.PosSourceArea, data, host);
};
const posgatherList = (data) => {
    return outter_post(PosApi.PosGatherList, data, host);
};
const poscollectionType = (data) => { //汇总类型
    return outter_post(PosApi.PosCollectionType, data, host);
};
const posStatistics = (data) => { //机具统计
    return outter_post(PosApi.PosStatistics, data, host);
};
const posimplementIssuedcz = (data) => { //机具下发
    return outter_post(PosApi.PosImplementIssuedcz, data, host);
};
const posimplementIssuedczpl = (data) => { //机具批量下发
    return outter_post(PosApi.PosImplementIssuedczpl, data, host);
};
const posimplementupstatus = (data) => { //修改状态
    return outter_post(PosApi.PosImplementUpstatus, data, host);
};
const getposSnAll = (data) => { //获取机具数量
    return outter_post(PosApi.GetPosSnAll, data, host);
};
const getposSnAllStandby = (data) => { //获取机具数量备用
    return outter_post(PosApi.GetPosSnAllStandby, data, host);
};
const chnCode = (data) => { //通道名称
    return outter_post(PosApi.ChnCode, data, host);
};
const status = (data) => { //状态
    return outter_post(PosApi.Status, data, host);
};

const postransferinfoList = (data) => {
    return outter_post(PosApi.PostransferinfoList, data, host);
};

const posrateList = (data) => { // 机具配置列表
    return outter_post(Merchant.PosrateList, data, host);
};
const posrateEdit = (data) => {
    return outter_post(Merchant.PosrateEdit, data, host);
};
const posrateInsert = (data) => {
    return outter_post(Merchant.PosrateInsert, data, host);
};
const posrateDel = (data) => {
    return outter_post(Merchant.PosrateDel, data, host);
};

//机具配置----费率
const posratemanageList = (data) => {
    return outter_post(Merchant.PosrateManageList, data, host);
};
const posratemanageEdit = (data) => {
    return outter_post(Merchant.PosrateManageEdit, data, host);
};
const posratemanageInsert = (data) => {
    return outter_post(Merchant.PosrateManageInsert, data, host);
};

const codeplateratemanageList = (data) => {   //码牌费率配置
    return outter_post(PosApi.CodePlaterateManageList, data, host);
};
const codeplateratemanageStatus = (data) => {
    return outter_post(PosApi.CodePlaterateManageStatus, data, host);
};

const codeplaterateinfoList = (data) => {  //码牌费率修改明细
    return outter_post(PosApi.CodePlaterateInfoList, data, host);
};

const ysposcodeplateratemanageList = (data) => {   //银盛大pos码牌费率配置
    return outter_post(PosApi.YsPosCodePlaterateManageList, data, host);
};
const ysposcodeplateratemanageStatus = (data) => {
    return outter_post(PosApi.YsPosCodePlaterateManageStatus, data, host);
};

const ysposcodeplaterateinfoList = (data) => {  //银盛大pos码牌费率修改明细
    return outter_post(PosApi.YsPosCodePlaterateInfoList, data, host);
};

export default {
    recoverycz,

    posmanageList,
    posmanagejijuInfo,
    posJiJuType,
    posYingJianType,
    posSuoShuType,
    posexchangeType,
    possourceArea,
    posgatherList,
    poscollectionType,
    posStatistics,
    posimplementIssuedcz,
    posimplementIssuedczpl,
    posimplementupstatus,
    getposSnAll,
    getposSnAllStandby,
    chnCode,
    status,

    postransferinfoList,

    posrateList,
    posrateEdit,
    posrateInsert,
    posrateDel,

    posratemanageList,
    posratemanageEdit,
    posratemanageInsert,

    codeplateratemanageList,
    codeplateratemanageStatus,

    codeplaterateinfoList,

    ysposcodeplateratemanageList,
    ysposcodeplateratemanageStatus,

    ysposcodeplaterateinfoList,
}



// WEBPACK FOOTER //
// ./src/service/Merchant.js